import { computed, ref } from 'vue';
import { searchInitInstance } from '@/services/search-init';
import { type IApiCommonInitResponse } from '@/types/init';

const limitations = ref<IApiCommonInitResponse['limitations']>(searchInitInstance.limitations);
searchInitInstance.deferred.promise
    .then(() => {
        limitations.value = searchInitInstance.limitations;
    });

export function useLimitation() {
    const maxQueryPreviewLength = computed(() => limitations.value.maxQueryPreviewLength);

    return {
        limitations,
        maxQueryPreviewLength,
    };
}
